import { render, staticRenderFns } from "./SignUpB2B.vue?vue&type=template&id=70b0fb72&scoped=true"
import script from "./SignUpB2B.vue?vue&type=script&lang=js"
export * from "./SignUpB2B.vue?vue&type=script&lang=js"
import style0 from "./SignUpB2B.vue?vue&type=style&index=0&id=70b0fb72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b0fb72",
  null
  
)

export default component.exports